// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"71e7bf3b","228":"8d749967","496":"38a523ed","506":"6ef5fdbd","525":"98408022","658":"f6eaf6ee"}[chunkId] + ".chunk.js";
};